import { PureComponent } from 'react';
import { v4 as uuid } from 'uuid';
import { FlowNode, flowNodeColor } from '../flowNode';
export const DEFAULT_PORTS_IN = (node) => [
    {
        id: node.parentId || uuid(),
        type: 'in',
        connection: node.parentId,
        label: node.connectionLabel,
    },
];
export const DEFAULT_PORTS_OUT = (_node) => [];
export const formatPortsHelper = (outPortFormatter = DEFAULT_PORTS_OUT, inPortFormater = DEFAULT_PORTS_IN) => (node) => {
    return [...outPortFormatter(node), ...inPortFormater(node)];
};
export function NodeTypeComponent() {
    class NodeTypeComponent extends PureComponent {
    }
    NodeTypeComponent.disabled = false;
    // Set defaults
    NodeTypeComponent.icon = 'dixa';
    NodeTypeComponent.label = 'Unknown';
    NodeTypeComponent.color = flowNodeColor.default;
    NodeTypeComponent.height = FlowNode.dimensions.h;
    NodeTypeComponent.width = FlowNode.dimensions.w;
    NodeTypeComponent.translatePayload = formatPortsHelper();
    NodeTypeComponent.updateConnection = (node, _port, _nodeId) => node;
    // no default
    NodeTypeComponent.actionTrigger = undefined;
    NodeTypeComponent.translateScopeVariables = undefined;
    NodeTypeComponent.ActionModal = null;
    return NodeTypeComponent;
}
